var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mia-feature-select',{attrs:{"value":_vm.mechanic,"label":"Mitarbeiter","options":_vm.mechanics,"name-by":function (mechanic) { return ((mechanic.lastname) + ", " + (mechanic.firstname)); },"track-by":"id"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }